/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type {
  GetStatsByDriversOverviewQueryResponse,
  GetStatsByDriversOverviewQueryParams,
  GetStatsByDriversOverview400,
} from '../entities/GetStatsByDriversOverview'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getGetStatsByDriversOverviewUrl() {
  return `/stats/by-drivers/overview` as const
}

/**
 * @description Get stats by drivers overview
 * @summary Get stats by drivers overview
 * {@link /stats/by-drivers/overview}
 */
export async function getStatsByDriversOverview(
  params?: GetStatsByDriversOverviewQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {},
) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<GetStatsByDriversOverviewQueryResponse, ResponseErrorConfig<GetStatsByDriversOverview400>, unknown>({
    method: 'GET',
    url: getGetStatsByDriversOverviewUrl().toString(),
    params,
    ...requestConfig,
  })
  return res.data
}